import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera'
import { useForm } from 'react-hook-form'
import { makePostRequest } from 'utils/api'
import urls from 'utils/urls'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 350,
  bgcolor: 'background.paper',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
}

export default function UploadProfile({ setUserVal }) {
  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      img: '',
    },
  })
  const [open, setOpen] = React.useState(false)
  const [img, setImg] = React.useState(null)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  // const imgref = React.useRef()
  const onSubmit = async () => {
    const formData = new FormData()

    // return
    formData.append('img', img)
    const { data, status } = await makePostRequest(
      urls.uploadImg,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    )
    if (status === 200) {
      setUserVal((pre) => ({ ...pre, img: data.id, img_url: data.img_url }))
      handleClose()
    }
  }
  return (
    <div>
      <PhotoCameraIcon onClick={handleOpen} sx={{ color: 'white', cursor: 'pointer' }} />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            display={'flex'}
            justifyContent={'center'}
            flexDirection={'column'}
            alignItems={'center'}
          >
            <Box mb={2} display={'flex'} width={'100%'} flexDirection={'column'}>
              <label>Profile Picture</label>
              <input
                width={'100%'}
                onChange={(e) => {
                  setImg(e.target.files[0])
                }}
                type="file"
                name="img"
              />
            </Box>
            <Button onClick={onSubmit}>Upload</Button>
          </Box>
        </Box>
      </Modal>
    </div>
  )
}
